import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/plan-management`;

export const plansManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:planId`,
  view: `${baseRoute}/view/:planId`,
} as const;

export type IPlansManagementRouteParams = IExtractRouteParamMap<
  typeof plansManagementRoutesObj
>;

export const plansManagementPath = createPaths<
  typeof plansManagementRoutesObj,
  IPlansManagementRouteParams
>(plansManagementRoutesObj);
